import { format, parseISO, differenceInCalendarDays } from 'date-fns'
import { FormattedStat } from '@/shared/constants/types'
import { SteamUserDataType } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const useFormatSteamStats = (userData: SteamUserDataType['userData'], userLang: keyof typeof lang) => {
  const units = lang[userLang].pages.units
  const texts = lang[userLang].pages.profile.overview

  const registeredAt = format(
    parseISO(userData.registredAt ? userData.registredAt.toString() : '1990-01-01T17:31:27.482597Z'),
    'MM.dd.yyyy'
  )

  const calculateDailyPlaytime = () => {
    if (!userData.registredAt || !userData.totalHoursPlayed) return ''
    const accountAgeInDays = differenceInCalendarDays(Date.now(), new Date(userData.registredAt))
    return (userData.totalHoursPlayed / accountAgeInDays).toFixed(2)
  }

  const basicStats: FormattedStat[] = [
    { name: texts.games_owned, value: userData.gamesOwned ?? 0, diff: userData.diff_games_count?.toString() ?? '0' },
    { name: texts.items_owned, value: userData.itemsOwned ?? 0, diff: userData.diff_items_count?.toString() ?? '0' },
    {
      name: texts.total_hours_played,
      value: userData.totalHoursPlayed ? `${userData.totalHoursPlayed} ${units.hours}` : '',
      unit: units.hours,
      diff: userData.diff_total_hours?.toString() ?? '0',
    },
    {
      name: texts.account_value,
      value: userData.totalValue ? '$ ' + userData.totalValue : '',
      diff: userData.diff_total_value_usd?.toString() ?? '0',
    },
  ]

  const plusStats: FormattedStat[] = [
    { name: texts.account_age, value: userData.accountAge ?? 0, unit: units.years, isPremiumStat: true },
    {
      name: texts.inventory_price,
      value: `${units.dollar} ${userData.inventoryPrice?.toFixed() ?? 0}`,
      isPremiumStat: true,
    },
    { name: texts.registration_date, value: registeredAt, isPremiumStat: true },
    {
      name: texts.daily_playtime,
      value: calculateDailyPlaytime(),
      unit: units.hours,
      isPremiumStat: true,
    },
  ]

  return {
    basicStats,
    plusStats,
    units,
    texts,
  }
}
